import React from 'react'
import { useAppLocale } from '../../i18n/localeUtils'
import { Link } from 'react-router'
import Stack from '@mui/material/Stack'
import { NoteListItem } from '@finance-lab/utils/types'
import IssueTypeLabels, { HasWarrantLabel, KVLabel } from '../../components/entities/IssueTypeLabels'
import { getUrlForType } from '../../utils/getUrlForEntity'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'

export const NoteEntityLink = ({ item }: { item: NoteListItem }) => {
    const { language } = useAppLocale()
    const href = getUrlForType({ entityType: item.entityType, id: item.entityId })
    return (
        <Stack direction='row' spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
            <Link to={href} style={{ paddingRight: 4 }}>
                {item.name}
            </Link>

            {item.entityType !== 'Warrant' ? null : (
                <div>
                    <HasWarrantLabel />
                </div>
            )}

            {item.entityType !== 'Issue' ? null : (
                <>
                    <div style={{ paddingRight: 4 }}>
                        {item.issueData && (
                            <IssueTypeLabels
                                hasWarrants={!!item.issueData.hasWarrants}
                                isRto={item.issueData.rto}
                                isSpac={item.issueData.spac}
                                issueType={item.issueData.type}
                                sharesInUnit={item.issueData.sharesInUnit}
                                unitExtraContent={item.issueData.unitExtraContent}
                            />
                        )}
                    </div>
                    <div>
                        {item.issueData
                            ? formatDateYYYYMMDD(
                                  item.issueData.ipoTradingDate ||
                                      item.issueData.subEndDate ||
                                      item.issueData.publicationDate,
                                  { locale: language },
                              )
                            : null}
                    </div>
                </>
            )}
            {item.entityType !== 'Convertible' ? null : (
                <div>
                    <KVLabel />
                </div>
            )}
        </Stack>
    )
}
